<template>
  <div :class="getClassName">
    {{ getNetworkMessage }}
  </div>
</template>
<script>
import { useWebproductStore } from "@/stores/modules/webproduct";
import { mapState, mapActions } from "pinia";

export default {
  computed: { ...mapState(useWebproductStore, ["getNetworkMessage"]) }
};
</script>
